var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"AddressText"},'div',_vm.$attrs,false),[(_vm.autoScroll && _vm.isAddress)?_c('TextScroll',{attrs:{"text":_vm.innerAddress || '--'}}):[_vm._v(" "+_vm._s((_vm.isAddress ? _vm.innerAddress : _vm.lngLatLabel) || '--')+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }